import { OfferCardWrapper } from "../../styles/StyledComponents/OfferCardWrapper";
import CardArrowIcon from "../../ui/icons/CardArrowIcon";
import { IOfferCardProps } from "../../ui/interface";

const OfferCard: React.FC<IOfferCardProps> = ({
  icon,
  title,
  descriptionText,
}) => {
  return (
    <OfferCardWrapper>
      <a href="#url" className="offer_card_Wrap">
        <i className="show_card_icon">{icon}</i>
        <div className="offer_cardText_wrap">
          <h3>{title}</h3>
          <p>{descriptionText}</p>
          <span className="cardArrowIcon">
            <CardArrowIcon />
          </span>
        </div>
      </a>
    </OfferCardWrapper>
  );
};

export default OfferCard;
